export default {
    namespaced: true,

    state: {
        show: false,
        text: "",
        color: "primary",
        timeout: 3000
    },

    mutations: {
        SHOW_SNACK(state, { text, color }) {

            state.text = text
            state.color = color
            state.show = true
        },
        HIDE_SNACK(state) {
            state.show = false
        }
    },

    actions: {
        show({ commit }, payload) {
            commit("SHOW_SNACK", payload)
        },
        hide({ commit }) {
            commit("HIDE_SNACK")
        }
    }
}
